import { render, staticRenderFns } from "./AttachedResponsibilitiesToARole.vue?vue&type=template&id=10c206a5&scoped=true"
import script from "./AttachedResponsibilitiesToARole.vue?vue&type=script&lang=js"
export * from "./AttachedResponsibilitiesToARole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c206a5",
  null
  
)

export default component.exports